import Main from '@/views/main/index.vue'
export const coreRouter = [
  { path: "/", redirect: "/main" },
  {
    path: "/main",
    name: "Main",
    component: Main,
    meta: {
      title: 'AI萌宠走秀'
    },
  },
  {
    path: "/generate",
    name: "generate",
    component: () => import("@/views/generate/index.vue"),
    meta: {
      title: 'AI萌宠走秀'
    },
  },
  {
    path: "/history",
    name: "History",
    component: () => import("@/views/history/index.vue"),
    meta: {
      title: 'AI萌宠走秀'
    },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login/index.vue"),
  }
]
